import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { EventService } from "./event.service";
import { ActivatedRoute } from "@angular/router";
import { EventLocation, EventModel } from "../models/event.model";
import { AuthService } from "../common/auth.service";
import { UserModel } from "../models/user.model";
import { Statuses } from "../data/statuses.data";
import {
  GenericFormType,
  GenericFormComponent,
} from "../generic-form/generic.form.component";
import * as moment from "moment";
import { EnumService } from "../common/enum.service";
import { Platforms } from '../event/tickets/ticket.enum';

import { VenueService } from "../venue/venue.service";
import { Router } from "@angular/router";
import { NotificationService } from "../common/notification.service";
import { neighborhood } from "src/configs/neighborhood";
import * as momentTz from 'moment-timezone';
import { UserRoles } from "../data/user.roles.data";
import { DialogService } from "../common/dialog/dialog.service";


@Component({
  selector: "app-event-profile",
  templateUrl: "./event.profile.component.html",
  styleUrls: ["./event.profile.component.scss"],
})
export class EventProfileComponent implements OnInit, OnDestroy {
  @ViewChild("OrdersFilterForm", { static: false }) ordersFilterForm: GenericFormComponent;
  @ViewChild("gmap", { static: false }) gmapElement: any;

  events: EventModel[];
  event: any;
  seats: number;
  currentUser: UserModel;
  shownDetails: string;
  statuses = Statuses;
  participants = [];
  filterParticipantsRules: GenericFormType[];
  venueNeighborhood: string;
  map: google.maps.Map;
  marker: any;
  images: any[];
  participantsToShow: any;
  remainingNumberOfParticipants: number;
  participantsLimit = 5;

  isUserRegisterForEvent: boolean = false;
  isUserFormerParticipant: boolean = false;
  isUserPotentialParticipant: boolean = false;
  isUserFormerPotentialParticipant: boolean = false;
  haveUserJoinRequests: boolean = false
  showPaymentPopup = false;
  showAttendeesPopup = false;
  eventId: string;
  eventNeedJoinApproval = false

  imagesReady: boolean = false;
  isMobile: boolean;
  availableTickets: number;
  eventLocation: EventLocation;
  eventSource!: EventSource

  defaultDescription = `Join Us for an Unforgettable Experience!

  Immerse yourself in the unique atmosphere of our upcoming event, designed to bring together like-minded individuals for a day/evening of engaging activities and enriching encounters. Whether you're a first-timer or a seasoned attendee, our Table promises something for everyone.

  What to Expect:

  Engaging Activities: Participate in a variety of sessions tailored to foster learning, creativity, and connection. Each Table is crafted to enhance your experience and engagement.

  Networking Opportunities: Meet and mingle with a diverse group of participants, each bringing their own unique perspectives and stories. Expand your network, exchange ideas, and build lasting relationships.

  Delicious Refreshments: Enjoy a selection of gourmet bites and refreshing beverages. Individual ordering makes it possible to cater to all tastes and dietary preferences, ensuring you stay energized and satisfied.

  Inspirational Atmosphere: Our venue is chosen specifically to inspire and delight. Whether indoors or outdoors, the space will complement the Table's theme and enhance your overall experience.

  We are excited to welcome you and look forward to creating memorable moments together!`;
  constructor(
    private eventService: EventService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private enumService: EnumService,
    private venueService: VenueService,
    private router: Router,
    private notificationService: NotificationService,
    private cr: ChangeDetectorRef,
    private dialogService: DialogService,
  ) { }

  async ngOnInit() {
    await this.init()
  }
  async init () {
    if (this.authService.isLoggedIn().value) {
      this.currentUser = await this.authService.refreshUserData();
    }
    this.isMobile = window.innerWidth < 768;
    const id: string = this.route.snapshot.paramMap.get("id");
    this.eventId = id;
    this.cr.detectChanges();
    await this.loadEvent(id);
    await this.getNeighborhood();
    this.getImages();
    // this.loadMap();
    this.getEventLocation(this.event.venue, this.event)
    await this.subscribeUserToEventUpdates(id)

  }

  async ngOnDestroy(){
    if (this.eventSource) {
      this.closeConection();
    }
  }
  private async getUserJoinRequest(id: string) {
    try {
      const requests = await this.eventService.getJoinRequestForUser(id)
      if(requests && requests.lifecycle.status === 'pending') {
        this.haveUserJoinRequests = true
      }
    } catch (error) {
      console.log('Error', error)
    }
  }

  private async loadEvent(id: string) {
    this.event = await this.eventService.getPublicById(id);
    this.eventNeedJoinApproval = !this.event.autoJoin

    await this.getUserJoinRequest(id)
    
    if (this.currentUser) {
     if(this.currentUser.role !== 'POTENTIAL') {
      const participants = [...this.event.participants, ...(this.event.potentialUsers || [])]
      this.isUserRegisterForEvent = participants.some((participant) => participant.id === this.currentUser.id);

      if (this.event.formerParticipants) {
        this.isUserFormerParticipant = this.event.formerParticipants.some((participant) => participant.email === this.currentUser.email);
      }
     }

      if(this.currentUser.role === 'POTENTIAL') {
        if (this.event.potentialUsers.length) {
          this.isUserPotentialParticipant = this.event.potentialUsers.some((participant) => participant.email === this.currentUser.email);
          if (this.isUserPotentialParticipant) {
            this.isUserRegisterForEvent = true;
          }
        }
  
        if (this.event.formerPotentialParticipants) {
          this.isUserFormerParticipant = this.event.formerPotentialParticipants.some((participant) => participant.email === this.currentUser.email);
          if (this.isUserFormerParticipant) {
            this.isUserRegisterForEvent = false;
            this.isUserFormerPotentialParticipant = true;
          }
        }
      }
    }



    if (this.event.tickets) {
      this.availableTickets = (this.event.tickets.totalAmount - this.event.tickets.available);
    }
    if (this.event.potentialUsers && this.event.potentialUsers.length) {
      this.seats = this.event.potentialUsers.length + this.event.participants.length;
      this.participants = [...this.event.participants, ...this.event.potentialUsers];
    } else {
      this.seats = this.event.participants.length;
      this.participants = this.event.participants;
    }

    if (this.event.eventStatus === Statuses.CANCELED) {
      this.notificationService.error(
        "Cancelled event",
        "This event has been cancelled"
      );
      this.router.navigate(["/events"]);
    }

    if (
      this.participants &&
      this.participants.length > this.participantsLimit
    ) {
      this.participantsToShow = this.participants.splice(
        0,
        this.participantsLimit
      );
      this.remainingNumberOfParticipants = this.participants.length;
    } else {
      this.participantsToShow = this.participants;
      this.remainingNumberOfParticipants = 0;
    }

    if ((this.event.entranceFee && this.event.tickets) && this.participantsToShow.length < this.availableTickets) {
      const remainParticipants = this.setUnclaimedTicketsAsDummyUsers(this.event, this.participantsToShow, this.availableTickets);
      const totalParticipants = [...this.participantsToShow, ...remainParticipants];
      this.participantsToShow = totalParticipants;
      if (
        totalParticipants &&
        totalParticipants.length > this.participantsLimit
      ) {
        this.participantsToShow = totalParticipants.splice(
          0,
          this.participantsLimit
        );
        this.remainingNumberOfParticipants = totalParticipants.length;
      } else {
        this.participantsToShow = totalParticipants;
        this.remainingNumberOfParticipants = 0;
      }
    }

    const timeZone = this.event.venue.timeZone ? this.event.venue.timeZone : 'America/New_York';
    const startZ = this.convertToTimezone(this.event.startDate, timeZone);
    const endZ = this.convertToTimezone(this.event.endDate, timeZone);
    this.event.startDate = startZ;
    this.event.endDate = endZ;
  }
  getEventLocation(venue: any, event: EventModel) {
    let location = venue.location
    if(venue.needLocation) {
      location = (event.location.latitude && event.location.longitude) ? event.location : venue.location
    }
    this.eventLocation = location
  }

  convertToTimezone(date: string | Date, timezone: string) {
    return momentTz(date).tz(timezone).format('YYYY-MM-DD HH:mm:ss');
  }

  setUnclaimedTicketsAsDummyUsers = (reservationInfo, attendees, availableTickets) => {
    if (
      !reservationInfo ||
      !reservationInfo.entranceFee ||
      !reservationInfo.tickets
    ) {
      return attendees;
    }
    const forGuests = (availableTickets - attendees.length);
    const usersWithdummyTicketUsers = [];
    if (forGuests) {
      for (let index = 0; index < forGuests; index++) {
        const userEmail = 'dummy';
        usersWithdummyTicketUsers.push(userEmail);
      }
    }
    return usersWithdummyTicketUsers;
  };

  loadMap() {
    const mapProp = {
      center: new google.maps.LatLng(44.787197, 20.457273),
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      streetViewControl: false,
      disableDoubleClickZoom: true,
      zoomControl: false,
      scrollwheel: false,
    };
    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
    const icon = {
      path: "M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z",
      fillColor: "#242847",
      fillOpacity: 0.9,
      anchor: new google.maps.Point(0, 0),
      strokeWeight: 0,
      scale: 0.55,
    };
    this.marker = new google.maps.Marker({
      position: {
        lat: this.eventLocation.latitude,
        lng: this.eventLocation.longitude,
      },
      map: this.map,
      draggable: false,
      icon,
    });
    this.map.setCenter(this.marker.getPosition());
  }

  getImages() {
    if (!!this.event.images && !!this.event.images.length) {
      this.images = this.event.images;
      this.imagesReady = true;
      return;
    }
    if (!!this.event.mainImage) {
      this.images = [this.event.mainImage];
      this.imagesReady = true;
      return;
    }
    this.images = this.event.venue.gallery;
    this.imagesReady = true;
    return;
  }

  isParticipant() {
    if (!this.currentUser) {
      return false;
    }
    return !!this.event.participants.find((x) => x.id === this.currentUser.id);
  }

  isEventEnded(){
    const now = moment();

    if(!this.event.endDate) {
      const endDate = moment(this.event.startDate).add(6, "hours").toISOString();
      return now.isAfter(endDate) && this.isEventJoineable()
    } 
    
    return now.isAfter(this.event.endDate) && this.isEventJoineable()
  }

  isEventJoineable() {
    return ![
      Statuses.CANCELED,
      Statuses.DECLINED,
      Statuses.REJECTED,
      Statuses.COMPLETED,
      Statuses.PAID,
    ].includes(this.event.eventStatus)
  }

  isEventActive() {
    const now = moment();
    // tslint:disable-next-line:max-line-length
    if (
      this.event.eventStatus === Statuses.APPROVED ||
      this.event.eventStatus === Statuses.PENDING ||
      this.event.eventStatus === Statuses.ACTIVE
    ) {
      if (!this.event.endDate) {
        const endDate = moment(this.event.startDate)
          .add(6, "hours")
          .toISOString();
        return now.isBefore(endDate);
      }
      return now.isBefore(this.event.endDate);
    } else {
      return false;
    }
  }

  getEventAddress() {
    if (this.eventLocation && this.eventLocation.address) {
      return { address: this.eventLocation.address, name: this.eventLocation.name };
    }
    return { address: this.eventLocation.address, name: this.venueNeighborhood };
  }

  async openGetTheAppPopup(): Promise<void> {
    const id = this.route.snapshot.paramMap.get("id");
  
    if (!id) {
      console.error("No event ID found in route.");
      return;
    }

    if (this.seats >= this.event.maxParticipants) {
      console.log(`Evento finalizado`);
      this.notificationService.error(`Event already have the maximal number of participants.`)
      return
    }
  
    if (!this.currentUser) {
      await this.router.navigateByUrl(`/rsvp/${id}`);
      return;
    }
  
    try {
      const { role, email, id: userId } = this.currentUser;
  
      if (role === UserRoles.POTENTIAL) {
        await this.registerPotentialUser(id, email);
      } else {
        await this.registerRegularUser(id, this.event.venue.id, userId);
      }
    } catch (error) {
      console.error("Error registering user:", error);
    }
  
    await this.loadEvent(id);
  }

  goToLogin() {
    const currentUrl = this.router.url;
    return this.router.navigate(['/login'], { queryParams: { returnUrl:  currentUrl} });
  }

  async registerPotentialUser(id: string, email: string) {
    const { error, success } = this.registerDialogMessage()
    try {
      const res = await this.eventService.JoinPotentialUSer(id, email);
      success();
      if(res && this.event.autoJoin) {
        setTimeout(() => {
          this.router.navigate(["/send-download-app"]);
        }, 1000);
      }
  
      return
    } catch (err) {
      return error();
    }
  }
  async registerRegularUser(eventId: string, venueId: string, userId: string) {
    const { error, success } = this.registerDialogMessage()
    try {
      const payload = {
        userId,
        venueId,
        platform: Platforms.WEB
      } as any
      const res = await this.eventService.sendJoinRequest(eventId, payload)
      return success()
    } catch (err) {
      this.showPaymentPopup = true
    }
  }

  async subscribeUserToEventUpdates(eventId: string) {
    if(!this.currentUser) {
      return;
    }
    if (!this.isParticipant()) {
      console.log(`User is not a participant, skipping subscription for event ID: ${eventId}`);
      return;
    }
    try {
      console.log(`Subscribing user ${this.currentUser.email} to event updates for event ID: ${eventId}`);
      await this.openConectionForEvents(eventId);
    } catch (error) {
      console.error('Error subscribing to event updates', 'Please try again later');
    }
  }

  async openConectionForEvents(eventId: string) {
    this.eventSource = await this.eventService.subscribeForEvent(eventId)
    this.eventSource.onmessage = async (event) => {
      const eventData = JSON.parse(event.data)
      console.log({prevEvent: this.event, newEvent: eventData.data});
      await this.init()
    }

    this.eventSource.onerror = (error) => {
      console.error(`Error en SSE`, error);
      this.closeConection()
    }
  }
  closeConection() {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
  }

  registerDialogMessage() {
    const error = (error?: any) => {
      let title = 'ERROR', text = 'An error occurred processing the event'
      if(error && error.data === "Processing ChargeAuthorization has failed."){
        title = '🔒 Add a Payment Method to RSVP'
        text = `To join this Table, you’ll need to have a card on file.
          Since you're using the web, please open the Cuculi app to securely add your payment method.
        `
        this.notificationService.warning(title, text)
        return;
      }
      this.notificationService.error(title, text );
    }
    const success = () => {
      if(this.event.autoJoin){
        this.dialogService.success({
          title: 'Successfully RSVPed!',
          subtitle: 'You\'re all set to join table ',
          html: `
          <div style="font-size: 2px;">
            <h3 style="font-weight: bold; font-size: clamp(18px, 5vw, 25px);"><strong style="font-weight: bold">Next Steps:</strong></h3  style="font-weight: bold; font-size: clamp(18px, 5vw, 25px);">
            <ul>
              <li style="font-size: clamp(15px, 3vw, 20px);">
                Download the app to see who else is joining and receive table updates.
              </li>
              <br>
              <li style="font-size: clamp(15px, 3vw, 20px);">
                Ensure you use the <strong style="font-weight: bold">same email address</strong> to sign up.
              </li>
            </ul>
          </div>
        `,
        });
      }else {
        this.dialogService.warning({
          title: 'Request Sent!',
          subtitle: 'Your request to join this table is pending approval.',
          html: `
          <div style="font-size: 2px;">
            <h3 style="font-weight: bold; font-size: clamp(18px, 5vw, 25px);"><strong style="font-weight: bold">Next Steps:</strong></h3  style="font-weight: bold; font-size: clamp(18px, 5vw, 25px);">
            <ul>
              <li style="font-size: clamp(15px, 3vw, 20px);">
                You'll be notified by email once your request is approved.
              </li>
              <li style="font-size: clamp(15px, 3vw, 20px);">
                Download the app to see who else is joining and receive table updates.
              </li>
              <br>
              <li style="font-size: clamp(15px, 3vw, 20px);">
                Make sure to sign up using the <strong style="font-weight: bold">same email address</strong> you used to RSVP.
              </li>
            </ul>
          </div>
        `,
        });
      }
    }
    return {error, success}
  }

  handleClosePaymentPopup() {
    this.showPaymentPopup = false
  }

  handleOpenAttendeesPopup() {
    console.log(`Pressing the button`);
    this.showAttendeesPopup = true
  }

  handleCloseAttendeesPopup() {
    this.showAttendeesPopup = false
  }

  async getNeighborhood() {
    // tslint:disable-next-line:max-line-length
    const neighborhoods = await this.enumService.getByTypes(neighborhood);
    if (!neighborhoods || !this.event.venue.neighborhood) {
      return (this.venueNeighborhood = "New York");
    }
    const element = neighborhoods.find(
      (n) => n.key === this.event.venue.neighborhood
    );
    this.venueNeighborhood =
      element && element.value ? element.value : this.event.venue.neighborhood;
  }

  async getAllEventsForUser() {
    this.events = await this.eventService.search({
      participants: this.currentUser.email,
    });
  }

  async openGoogleRatingInBrowser(venue) {
    const googlePlaceId = await this.venueService.getVenuesGoogleInfo(venue.id);
    const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      venue.name
    )}&query_place_id=${googlePlaceId}`;
    if (!googlePlaceId) {
      return;
    }
    return window.open(url, "_blank");
  }

  async handleCancelRegistration(value: boolean) {

    if (this.event.eventId) {
      this.event.id = this.event.eventId;
    };

    try {
      const isUserOnPotentialList = (this.event.potentialUsers || []).some(user => user.email === this.currentUser.email)
      const res = await this.eventService.leaveEvent(this.event, this.currentUser.email, isUserOnPotentialList);
      if (res) {
        this.isUserRegisterForEvent = false;
        this.isUserFormerParticipant = true;
        await this.init()
      }
    } catch (error) {
      const errorHost = "Host can not leave reservation unless there is a co-Host assigned"
      if (error.statusCode === 400 && error.data === errorHost) {
        const msg = `Hosts can only cancel Tables using the app. Please use the app to proceed`
        this.notificationService.clear();
        this.notificationService.error(msg);
      }
    }

  }

  async handleCreateRegistration(value: boolean) {
    if (this.event.eventId) {
      this.event.id = this.event.eventId;
    };

    if (this.isUserPotentialParticipant || this.isUserFormerPotentialParticipant) {
      await this.eventService.JoinPotentialUSer(this.event.eventId, this.currentUser.email).catch(e => this.notificationService.error('Error joining the potential user to the table'));
      this.isUserRegisterForEvent = true;
      this.isUserFormerParticipant = false;
      this.cr.detectChanges();
      return await this.init()
    }

    const res = await this.eventService.sendJoinRequest(this.event.id, {
      userId: this.currentUser.id,
      venueId: this.event.venue.id,
      platform: Platforms.WEB
    });

    if (res && this.event.autoJoin) {
      this.isUserRegisterForEvent = true;
      this.isUserFormerParticipant = false;
    }

    this.cr.detectChanges();
    await this.init()
  }
}
